import { Trans } from 'react-i18next'

import excellentKnowledgePNG from '~/assets/images/anatomy/excellent-knowledge.png'
import excellentKnowledgeWEBP from '~/assets/images/anatomy/excellent-knowledge.webp'
import { InfoPageStyles as S } from '~/pages/anatomy/libs/infoPageStyles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const ExcellentKnowledge = ({ nextPagePath, pageId }: TPageProps) => {
  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: 'Excellent knowledge!',
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ImageWrapper>
          <picture>
            <source srcSet={excellentKnowledgeWEBP} type="image/webp" />
            <img src={excellentKnowledgePNG} alt="Excellent Knowledge" />
          </picture>
        </S.ImageWrapper>

        <S.Title>
          <Trans ns="anatomy" i18nKey="onboarding.excellentKnowledge.title" />
        </S.Title>

        <S.Subtitle>
          <Trans
            ns="anatomy"
            i18nKey="onboarding.excellentKnowledge.subtitle"
          />
        </S.Subtitle>

        <S.StyledButton type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.StyledButton>
      </S.StyledContainer>
    </S.Root>
  )
}

export default ExcellentKnowledge
